// import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
// import Home from "./pages/Home";
// import AllProducts from "./pages/AllProducts";
// import CartScreen from "./pages/CartPage";
// import { Toaster } from "react-hot-toast";
// import CheckoutScreen from "./pages/CheckoutScreen";
// import OrdersScreen from "./pages/OrdersScreen";
// import ThankYouScreen from "./pages/ThankYouScreen";
// import DiscountedProducts from "./pages/DiscountedProducts";
// import FloatingCartButton from "./components/FloatingCartButton";
// import ShopScreen from "./pages/ShopScreen";
// import MainCategory from "./pages/MainCategory";
// import WhyHlcMain from "./pages/WhyHlcMain";
// import BlogScreen from "./pages/BlogScreen";
// import ContactPage from "./pages/ContactPage";
// import StoreLocator from "./pages/StoreLocator";
// import ShippingReturnPolicy from "./pages/ShippingReturnPolicy";
// import WarrantyPolicy from "./pages/WarrantyPolicy";
// import Faqs from "./pages/Faqs";
// import AboutHLC from "./pages/AboutHLC";
// import DealerPortal from "./pages/DealerPortal";
// import Careers from "./pages/Careers";
// import NewsEvents from "./pages/NewsEvents";
// import SiteMap from "./pages/SiteMap";
// import LedBasics from "./pages/LedBasics";
// import HomeLightingTips from "./pages/HomeLightingTips";
// import EnergySavings from "./pages/EnergySavings";
// import OutdoorFloods from "./pages/OutdoorFloods";
// import RopeLightIdeas from "./pages/RopeLightIdeas";
// import TermsOfUse from "./pages/TermsOfUse";
// import PrivacyPolicy from "./pages/PrivacyPolicy";
// import Accessibility from "./pages/Accessibility";
// import CookieNotice from "./pages/CookieNotice";
// import PrivacyRights from "./pages/PrivacyRights";
// import SolutionsPage from "./pages/SolutionsPage";
// import ProductByCategories from "./pages/ProductByCategories";
// import ResidentialPage from "./pages/ResidentialPage";
// import CommercialPage from "./pages/CommercialPage";
// import IndustrialPage from "./pages/IndustrialPage";
// import ProductByApplication from "./pages/ProductbyApplication";
// import ProductDetail from "./pages/ProductDetail";
// import Calculator from "./pages/Calculator";
// import AboutPage from "./pages/AboutPage";
// import ScrollToTop from "./components/ScrollToTop";
// import HlcBlogPage from "./pages/BlogScreen";
// import SingleBlogPage from "./pages/SingleBlogPage";
// import HLCSplashScreen from "./pages/Splash";
// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// function AppContent() {
//   const location = useLocation();
//   const [splash, setSplash] = useState(true);
//   const navigate = useNavigate();
//   // Hide the floating button on cart & checkout pages
//   const hideFloatingButton =
//     location.pathname === "/cart" || location.pathname === "/checkout";

//       if (splash) {
//     return (
//       <HLCSplashScreen
//         onComplete={() => {
//           setSplash(false);
//           navigate("/home"); // 👈 go to home
//         }}
//       />
//     );
//   }


//   return (
//     <div className="relative min-h-screen">
//       <Routes>
//         <Route path="/home" element={<Home />} />
//         <Route path="/all-products" element={<AllProducts />} />
//         <Route path="/cart" element={<CartScreen />} />
//         <Route path="/checkout" element={<CheckoutScreen />} />
//         <Route path="/orders" element={<OrdersScreen />} />
//         <Route path="/thank-you" element={<ThankYouScreen />} />
//         <Route path="/discounted-products" element={<DiscountedProducts />} />
//         <Route path="/shop" element={<ShopScreen />} />
//         <Route path="/whyhlc" element={<WhyHlcMain />} />
//         <Route path="/categories" element={<MainCategory />} />
//         <Route path="/blogs" element={<HlcBlogPage />} />
//         <Route path="/single-blog" element={<SingleBlogPage />} />
//         <Route path="/contact" element={<ContactPage />} />
//         <Route path="/store-locator" element={<StoreLocator />} />
//         <Route path="/shipping-returns" element={<ShippingReturnPolicy />} />
//         <Route path="/warranty" element={<WarrantyPolicy />} />
//         <Route path="/faqs" element={<Faqs />} />
//         <Route path="/about-hlc" element={<AboutHLC />} />
//         <Route path="/about-hlc" element={<BlogScreen />} />
//         <Route path="/news-events" element={<NewsEvents />} />
//         <Route path="/careers" element={<Careers />} />
//         <Route path="/dealer" element={<DealerPortal />} />
//         <Route path="/site-map" element={<SiteMap />} />
//         <Route path="/led-basics" element={<LedBasics />} />
//         <Route path="/home-lighting-tips" element={<HomeLightingTips />} />
//         <Route path="/energy-savings" element={<EnergySavings />} />
//         <Route path="/outdoor-floods" element={<OutdoorFloods />} />
//         <Route path="/rope-light-ideas" element={<RopeLightIdeas />} />
//         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//         <Route path="/terms-of-use" element={<TermsOfUse />} />
//         <Route path="/accessibility" element={<Accessibility />} />
//         <Route path="/cookie-notice" element={<CookieNotice />} />
//         <Route path="/privacy-rights" element={<PrivacyRights />} />
//         <Route path="/solutions" element={<SolutionsPage />} />
//         <Route path="/product-by-categories" element={<ProductByCategories />} />
//         <Route path="/residential" element={<ResidentialPage />} />
//         <Route path="/commercial" element={<CommercialPage />} />
//         <Route path="/industrial" element={<IndustrialPage />} />
//         <Route path="/product-by-application" element={<ProductByApplication />} />
//          <Route path="/product/:id" element={<ProductDetail />} />
//          <Route path="/calculator" element={<Calculator />} />
//          <Route path="/about" element={<AboutPage />} />


//       </Routes>

//       {!hideFloatingButton && <FloatingCartButton />}
//     </div>
//   );
// }

// function App() {
//   return (
//     <>
//       <Router>
//           <ScrollToTop />
//         <AppContent />
//       </Router>
//       <Toaster position="bottom-center" />
//     </>
//   );
// }

// export default App;

import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import AllProducts from "./pages/AllProducts";
import CartScreen from "./pages/CartPage";
import { Toaster } from "react-hot-toast";
import CheckoutScreen from "./pages/CheckoutScreen";
import OrdersScreen from "./pages/OrdersScreen";
import ThankYouScreen from "./pages/ThankYouScreen";
import DiscountedProducts from "./pages/DiscountedProducts";
import FloatingCartButton from "./components/FloatingCartButton";
import ShopScreen from "./pages/ShopScreen";
import MainCategory from "./pages/MainCategory";
import WhyHlcMain from "./pages/WhyHlcMain";
import ContactPage from "./pages/ContactPage";
import StoreLocator from "./pages/StoreLocator";
import ShippingReturnPolicy from "./pages/ShippingReturnPolicy";
import WarrantyPolicy from "./pages/WarrantyPolicy";
import Faqs from "./pages/Faqs";
import AboutHLC from "./pages/AboutHLC";
import DealerPortal from "./pages/DealerPortal";
import Careers from "./pages/Careers";
import NewsEvents from "./pages/NewsEvents";
import SiteMap from "./pages/SiteMap";
import LedBasics from "./pages/LedBasics";
import HomeLightingTips from "./pages/HomeLightingTips";
import EnergySavings from "./pages/EnergySavings";
import OutdoorFloods from "./pages/OutdoorFloods";
import RopeLightIdeas from "./pages/RopeLightIdeas";
import TermsOfUse from "./pages/TermsOfUse";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Accessibility from "./pages/Accessibility";
import CookieNotice from "./pages/CookieNotice";
import PrivacyRights from "./pages/PrivacyRights";
import SolutionsPage from "./pages/SolutionsPage";
import ProductByCategories from "./pages/ProductByCategories";
import ResidentialPage from "./pages/ResidentialPage";
import CommercialPage from "./pages/CommercialPage";
import IndustrialPage from "./pages/IndustrialPage";
import ProductByApplication from "./pages/ProductbyApplication";
import ProductDetail from "./pages/ProductDetail";
import Calculator from "./pages/Calculator";
import AboutPage from "./pages/AboutPage";
import ScrollToTop from "./components/ScrollToTop";
import HlcBlogPage from "./pages/BlogScreen";
import SingleBlogPage from "./pages/SingleBlogPage";
import HLCSplashScreen from "./pages/Splash";
import NotFound from "./pages/NotFound";
import { useState } from "react";

// ================= PHASE 1.5 — CLIENT REQUEST =================
// TEMPORARILY DISABLED: the Splash Screen no longer shows on load.
// HLCSplashScreen itself, its import, and every reference below are
// fully preserved — this single flag is the only thing gating it.
// To restore: set SPLASH_ENABLED back to true.
const SPLASH_ENABLED = false;

function AppContent() {
  const location = useLocation();
  const [splashDone, setSplashDone] = useState(
    () => !SPLASH_ENABLED || sessionStorage.getItem("hlc_splash_done") === "true"
  );

  const hideFloatingButton =
    location.pathname === "/cart" || location.pathname === "/checkout";

  // The home page content we want to reveal during the tear
  const homeContent = (
    <div className="relative min-h-screen">
      <Home />
    </div>
  );

  // After splash is fully done, render the full router normally
  if (splashDone) {
    return (
      <div className="relative min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/all-products" element={<AllProducts />} />
          <Route path="/cart" element={<CartScreen />} />
          <Route path="/checkout" element={<CheckoutScreen />} />
          <Route path="/orders" element={<OrdersScreen />} />
          <Route path="/thank-you" element={<ThankYouScreen />} />
          <Route path="/discounted-products" element={<DiscountedProducts />} />
          <Route path="/shop" element={<ShopScreen />} />
          <Route path="/whyhlc" element={<WhyHlcMain />} />
          <Route path="/categories" element={<MainCategory />} />
          <Route path="/blogs" element={<HlcBlogPage />} />
          <Route path="/single-blog" element={<SingleBlogPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/store-locator" element={<StoreLocator />} />
          <Route path="/shipping-returns" element={<ShippingReturnPolicy />} />
          <Route path="/warranty" element={<WarrantyPolicy />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/about-hlc" element={<AboutHLC />} />
          <Route path="/news-events" element={<NewsEvents />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/dealer" element={<DealerPortal />} />
          <Route path="/site-map" element={<SiteMap />} />
          <Route path="/led-basics" element={<LedBasics />} />
          <Route path="/home-lighting-tips" element={<HomeLightingTips />} />
          <Route path="/energy-savings" element={<EnergySavings />} />
          <Route path="/outdoor-floods" element={<OutdoorFloods />} />
          <Route path="/rope-light-ideas" element={<RopeLightIdeas />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/cookie-notice" element={<CookieNotice />} />
          <Route path="/privacy-rights" element={<PrivacyRights />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/product-by-categories" element={<ProductByCategories />} />
          <Route path="/residential" element={<ResidentialPage />} />
          <Route path="/commercial" element={<CommercialPage />} />
          <Route path="/industrial" element={<IndustrialPage />} />
          <Route path="/product-by-application" element={<ProductByApplication />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        {!hideFloatingButton && <FloatingCartButton />}
      </div>
    );
  }

  // During splash: show splash wrapping the home page (tear reveals it)
  return (
    <HLCSplashScreen
      onComplete={() => {
        sessionStorage.setItem("hlc_splash_done", "true");
        setSplashDone(true);
      }}
    >
      {homeContent}
    </HLCSplashScreen>
  );
}

function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <AppContent />
      </Router>
      <Toaster position="bottom-center" />
    </>
  );
}

export default App;